<!--
 * @Author: zhonghao
 * @Date: 2023-10-19 11:01:07
-->
<template>
  <div class="coupon">
    <!-- <div class="flex-div">
      <div class="flex-txt cur">全部</div>
      <div class="flex-txt">已使用</div>
      <div class="flex-txt">未使用</div>
    </div> -->
    <div class="list" v-if="couponList.length > 0 && !isNone">
      <div class="overlay-coupon-con" v-for="(item, index) in couponList" :key="index">
        <div class="overlay-coupon-block">
          <div class="overlay-coupon-flex">
            <div class="overlay-coupon-left">
              <div class="overlay-txt2">{{ item.title }}</div>
              <div class="overlay-txt3">
                <span class="tag">{{ item.end_time }}到期</span>
                <!-- 未使用 -->
              </div>
            </div>
            <div class="overlay-coupon-left2">
              <div class="overlay-txt5">{{ item.price }}</div>
              <div class="overlay-txt6">限角色使用｜年会员</div>
            </div>
          </div>
          <div class="overlay-txt4">
            限:开通{{ item.title }}可使用。
            <div class="btn" @click="handleClick(item)">去使用</div>
          </div>
        </div>
      </div>
      <!-- <div class="overlay-coupon-con">
        <div class="overlay-coupon-block ised">
          <div class="overlay-coupon-flex">
            <div class="overlay-coupon-left">
              <div class="overlay-txt2">联合会员V1优惠劵</div>
              <div class="overlay-txt3">
                <span class="tag">已使用</span>
              </div>
            </div>
            <div class="overlay-coupon-left2">
              <div class="overlay-txt5">597</div>
              <div class="overlay-txt6">限角色使用｜年会员</div>
            </div>
          </div>
          <div class="overlay-txt4">
            限:开通联合会员V1可使用。
          </div>
        </div>
      </div> -->
    </div>
    <div class="overlay-coupon-none" v-else-if="isNone && couponList.length <= 0">
      <img src="@/assets/images_member/20231018/img(14).png" class="none-img" alt="">
      <div class="none-txt">暂无可用优惠劵哦～</div>
      <div class="none-btn">查看我的优惠劵</div>
    </div>
  </div>
</template>
<script>
import { coupon } from '@/api/person'
export default {
  data () {
    return {
      couponList: [],
      isNone: false
    }
  },
  mounted () {
    coupon({ page: 1, num: 100 }).then(res => {
      this.couponList = res.data
      this.isNone = this.couponList.length <= 0
    })
  },
  methods: {
    handleClick(item) {
      window.location.href = item.use_link
    }
  }
}
</script>
<style lang="less" scoped>
.coupon {
  width: 100%;
  min-height: 100vh;
  background-color: #1E2020;
  padding-top: 14px;
  box-sizing: border-box;

  .flex-div {
    display: flex;
    align-items: center;
    height: 56px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    justify-content: space-around;
    background-color: #1E2020;

    .flex-txt {
      color: #CCCCCC;
      font-size: 14px;

      &.cur {
        color: #F0E1C0;
        font-weight: 600;
        position: relative;
        height: 56px;
        line-height: 56px;

        &::after {
          position: absolute;
          width: 32px;
          height: 2px;
          content: '';
          background-color: #F0E1C0;
          left: 50%;
          transform: translateX(-50%);
          bottom: 12px;
        }
      }
    }
  }

  .list {
    padding: 0 14px;
    box-sizing: border-box;

    .overlay-coupon-block {
      background-color: #fff;
      border-radius: 10px;
      padding: 0 14px;
      box-sizing: border-box;
      margin-bottom: 10px;

      &.ised {

        .overlay-txt2,
        .overlay-txt4,
        .overlay-txt5,
        .overlay-txt6 {
          color: #CCCCCC !important;
        }

        .overlay-txt3 {
          .tag {
            color: #fff !important;
            background-color: #CCCCCC !important;
          }
        }
      }

      .overlay-coupon-flex {
        display: flex;
        align-items: center;
        padding: 24px 0;
        box-sizing: border-box;

        .icon-check {
          width: 20px;
          height: 20px;
          display: block;
          margin-left: 10px;
        }

        .overlay-coupon-left {
          flex: 1;

          .overlay-txt2 {
            font-size: 20px;
            color: #212121;
            font-weight: bold;
            line-height: 20px;
            margin-bottom: 12px;
          }

          .overlay-txt3 {
            display: flex;
            align-items: center;
            color: #9C8964;
            font-size: 12px;
            font-weight: 500;

            .tag {
              margin-right: 8px;
              background-color: #F0E1C0;
              border-radius: 3px;
              height: 20px;
              text-align: center;
              line-height: 20px;
              font-size: 12px;
              color: #504632;
              font-weight: 500;
              padding: 0 5px;
            }
          }
        }

        .overlay-coupon-left2 {
          text-align: right;

          .overlay-txt5 {
            font-size: 30px;
            color: #E63429;
            line-height: 30px;
            font-weight: 600;
            margin-bottom: 10px;
            position: relative;
            display: inline-block;

            &::before {
              position: absolute;
              font-size: 16px;
              left: -16px;
              bottom: -2px;
              content: '￥';
            }
          }

          .overlay-txt6 {
            color: #504632;
            font-weight: 500;
            font-size: 12px;
          }
        }
      }

      .overlay-txt4 {
        color: #7A7A7A;
        font-size: 12px;
        height: 48px;
        line-height: 48px;
        box-sizing: border-box;
        background-image: url('../../assets/images_member/20231018/img(2).png');
        background-repeat: no-repeat;
        background-size: contain;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .btn {
          width: 74px;
          height: 28px;
          text-align: center;
          line-height: 28px;
          border-radius: 100px;
          border: 1px solid #E63429;
          font-size: 14px;
          color: #E63429;
          font-weight: 500;
        }
      }
    }
  }

  .none-img {
    margin-left: 50%;
    transform: translateX(-50%);
    width: 118px;
    display: block;
    margin-top: 110px;
  }

  .none-txt {
    font-size: 16px;
    color: #999999;
    line-height: 16px;
    margin-top: 16px;
    text-align: center;
    margin-bottom: 20px;
  }

  .none-btn {
    margin-left: 50%;
    transform: translateX(-50%);
    width: 110px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    background-color: #F0E1C0;
    border-radius: 100px;
    font-size: 12px;
    color: #313333;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/openMenber/coupon.vue